import { render } from "./QSelectZaloGroups.vue?vue&type=template&id=e6a4d3f8"
import script from "./QSelectZaloGroups.vue?vue&type=script&lang=js"
export * from "./QSelectZaloGroups.vue?vue&type=script&lang=js"

import "./QSelectZaloGroups.vue?vue&type=style&index=0&id=e6a4d3f8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__